<template>
  <MailForwardDataTable
      :loading="loading"
      :forwardTasks="forwardTasks"
      @update="onUpdate"
      :allow-create-print-package="false"
      :allow-operations="false"
  />
</template>

<script>
import _ from 'underscore'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {AllowMailForward} from "@/enums/permission";
import MailForwardDataTable from "@/components/MailForwardDataTable.vue";
import MailForwardService from "@/services/mail.forward.service";

export default {
  name: "MailForwardView",
  components: {
    MailForwardDataTable,
  },
  data() {
    return {
      forwardTasks: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    isAllowMailsForward() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowMailForward
      })
    },
  },
  methods: {
    onUpdate(filters) {
      this.reloadMailForward(filters)
    },
    reloadMailForward(filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {isActive} = filters;

      MailForwardService.get(isActive)
        .then(response => {
          this.forwardTasks = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch(LAYOUT_LOADING_STOP)
        })
      }
  },
  created() {
    if (this.isAllowMailsForward) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Авто-досыл')
    } else {
      this.$router.go(-1)
    }
  }
}

</script>


